import { type BasePageParams } from '@/app/urls/url-mapping';
import {
  type AvailableCourseTrack,
  type UrlEntry,
  type UrlRegion,
} from '@/types';

export const isIndexable = false;

export type QuizMatchParams = { course: AvailableCourseTrack } & BasePageParams;

export type QuizMatchPages = `quizMatch/${AvailableCourseTrack}`;

export const urls: Record<
  QuizMatchPages,
  Partial<Record<UrlRegion, UrlEntry>>
> = {
  'quizMatch/ai': {
    de: 'kunstliche-intelligenz/match',
    'de-en': 'artificial-intelligence/match',
    es: 'inteligencia-artificial/match',
    'es-en': 'artificial-intelligence/match',
    fr: 'intelligence-artificielle/match',
    'fr-en': 'artificial-intelligence/match',
    pt: 'inteligencia-artificial/match',
    'pt-en': 'artificial-intelligence/match',
  },
  'quizMatch/cy': {
    de: 'cybersecurity/match',
    'de-en': 'cybersecurity/match',
    es: 'ciberseguridad/match',
    'es-en': 'cybersecurity/match',
    fr: 'cybersecurite/match',
    'fr-en': 'cybersecurity/match',
    pt: 'ciberseguranca/match',
    'pt-en': 'cybersecurity/match',
  },
  'quizMatch/da': {
    de: 'data-analytics/match',
    'de-en': 'data-analytics/match',
    es: 'data-analytics/match',
    'es-en': 'data-analytics/match',
    fr: 'data-analytics/match',
    'fr-en': 'data-analytics/match',
    pt: 'data-analytics/match',
    'pt-en': 'data-analytics/match',
  },
  'quizMatch/dv': {
    de: 'devops-cloud-computing/match',
    'de-en': 'devops-cloud-computing/match',
    es: 'devops-cloud-computing/match',
    'es-en': 'devops-cloud-computing/match',
    fr: 'devops-cloud-computing/match',
    'fr-en': 'devops-cloud-computing/match',
    pt: 'devops-cloud-computing/match',
    'pt-en': 'devops-cloud-computing/match',
  },
  'quizMatch/mk': {
    de: 'digital-marketing/match',
    'de-en': 'digital-marketing/match',
    es: 'marketing-digital/match',
    'es-en': 'digital-marketing/match',
    fr: 'marketing-digital/match',
    'fr-en': 'digital-marketing/match',
    pt: 'marketing-digital/match',
    'pt-en': 'digital-marketing/match',
  },
  'quizMatch/ml': {
    de: 'data-science-machine-learning/match',
    'de-en': 'data-science-machine-learning/match',
    es: 'data-science-machine-learning/match',
    'es-en': 'data-science-machine-learning/match',
    fr: 'data-science-machine-learning/match',
    'fr-en': 'data-science-machine-learning/match',
    pt: 'data-science-machine-learning/match',
    'pt-en': 'data-science-machine-learning/match',
  },
  'quizMatch/ux': {
    de: 'ux-ui-design/match',
    'de-en': 'ux-ui-design/match',
    es: 'diseno-ux-ui/match',
    'es-en': 'ux-ui-design/match',
    fr: 'ux-ui-design/match',
    'fr-en': 'ux-ui-design/match',
    pt: 'ux-ui-design/match',
    'pt-en': 'ux-ui-design/match',
  },
  'quizMatch/wd': {
    de: 'webentwicklung/match',
    'de-en': 'web-development/match',
    es: 'desarrollo-web/match',
    'es-en': 'web-development/match',
    fr: 'developpement-web/match',
    'fr-en': 'web-development/match',
    pt: 'programacao-web/match',
    'pt-en': 'web-development/match',
  },
};

export const getQuizMatchPageType = (
  params: QuizMatchParams
): QuizMatchPages => {
  const { course } = params;
  return `quizMatch/${course}`;
};
